import {getFieldTypeFromFieldName} from "../utils/functions";
import {FIELD_TYPE} from "../enums/fieldType";

export default {
  methods: {
    isSharedFormPreviewType(name){
      return getFieldTypeFromFieldName(name) === FIELD_TYPE.SHARED_FORM_PREVIEW
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/fieldTypeUtils.js